import * as FlexWebChat from "@twilio/flex-webchat-ui"
import { Button } from '@twilio/flex-webchat-ui'
import axios from 'axios'
import React from 'react'
import { surveyValidator } from '../validators'
import { BooleanInput } from './BooleanInput'
import { RatingInput } from './RatingInput'
export class SurveyForm extends React.Component {
  state = {
    model: {
      solved: null,
      ratingAttendant: null,
      ratingCompany: 0,
      comment : null,
    },
    errors: {},
    submittedOneTime: false,
    sending: false,
    success: false,
  }

  render () {
    this.setAwaitingTime()
    const { sending, success } = this.state
    const fields = this._renderFields()
    const classes = ['survey-form']
    if (success) {
      classes.push('survey-form--sent')
    }
    return (
      <form
        onSubmit={this._handleSubmit}
        className={classes.join(' ')}
      >
        <div className="survey-form__wrapper">
          <h2 className="survey-form__title">
            Sua opinião é muito importante :)
          </h2>
          {fields}
          <div className="survey-form__actions">
            <Button
              disabled={sending || success}
              type="submit"
              className="survey-form__actions__button"
              style={{
                color: 'white',
                background: '#ed3624',
                borderRadius: '0',
              }}
            >Enviar</Button>
          </div>
        </div>
        {success && (
          <div className="survey-form__success">
            <h2 className="survey-form__title">
              Obrigado pela conversa!
            </h2>
            <p className="survey-form__text">
              Se houver mais dúvidas, entre em contato novamente.
            </p>
            <Button
              type="button"
              className="survey-form__actions__button"
              onClick={this._startNewChat}
              style={{
                borderRadius: '0',
                color: 'white',
                backgroundColor: '#FC481E',
              }}
            >Iniciar uma nova conversa</Button>
          </div>
        )}
      </form>
    )
  }

  setAwaitingTime = async () => {
    try {
      const state = this.props.manager.store.getState()
      const { session} = state.flex
      const { channelSid, tokenPayload } = session

      const body = {
        channelSid,
        Token: tokenPayload?.token
      }
      const options = {
        method: "POST",
        body: new URLSearchParams(body),
        headers: {
        "Content-Type": "application/x-www-form-urlencoded"
        }
      }

      await fetch('https://atendimento-twilio-functions-7351.twil.io/timerBot/addAwaitingUserTimeOnTask', options)
    } catch (error) {
      console.error(error)
    }
  }

  _renderFields = () => {
    const { model, errors } = this.state
    const fields = this._getFields()
    return fields.map((field, index) => {
      const value = model[field.field]
      let input
      switch (field.type) {
        case 'boolean':
          input = (
            <BooleanInput
              field={field.field}
              label={field.label}
              value={value}
              onChange={this._handleChange}
            />
          )
          break

        case 'rating':
          input = (
            <RatingInput
              field={field.field}
              label={field.label}
              value={value}
              options={field.options}
              onChange={this._handleChange}
            />
          )
          break

        default:
          input = (
            <div className="textarea-input">
              <label className="textarea-input__label">{field.label}</label>
              <textarea
                className="textarea-input__textarea"
                name={field.field}
                rows={3}
                onChange={e => {
                  this._handleChange({
                    field: field.field,
                    value: e.target.value,
                  })
                }}
                value={field.value}
              />
            </div>
          )
          break
      }
      let errorItem
      if (errors[field.field]) {
        errorItem = (
          <div className="survey-form__control__error">{errors[field.field]}</div>
        )
      }
      return (
        <div
          className="survey-form__control"
          key={index}
        >
          {input}
          {errorItem}
        </div>
      )
    })
  }

  _getFields = () => {
    const { flex } = this.props.manager.store.getState()
    const { users } = flex.chat
    let attendant = 'atendente'
    Object.keys(users).forEach((username) => {
      if (username.length !== 32) {
        attendant = users[username].friendlyName
      }
    })
    return [
      {
        field: 'ratingAttendant',
        label: `Como você avalia o atendimento realizado por ${attendant}?`,
        type: 'rating',
        options: [
          { value: 1, label: 'Péssimo' },
          { value: 2, label: 'Ruim' },
          { value: 3, label: 'Regular' },
          { value: 4, label: 'Bom' },
          { value: 5, label: 'Ótimo' },
        ],
      },
      {
        field: 'comment',
        label: 'Comente aqui onde podemos melhorar :)',
        type: 'textarea',
      },
    ]
  }

  _handleSubmit = e => {
    e.preventDefault()
    try {
      const state = this.props.manager.store.getState()
      const data = { ...this.state.model }
      surveyValidator.create(data).then(result => {
        this.setState({
          errors: result.errors || {},
          submittedOneTime: true,
        })
        if (result.success) {
          this.setState({ sending: true }, async () => {
            const channelSid = state.flex.session.channelSid
            const tokenPayloadIdentity = state.flex.session.tokenPayload.identity
            const tokenPayloadToken = state.flex.session.tokenPayload.token
            const accountSid = state.flex.config.accountSid
            const flexFlowSid = state.flex.config.flexFlowSid
            const payload = {
              survey: data,
              channelSid,
              accountSid,
              flexFlowSid,
              tokenPayloadIdentity,
              tokenPayloadToken,
            }
            const url = process.env.REACT_APP_SURVEY_URL
            const result = await axios.post(url, { data: payload })
            this.setState({ ...result.data })
          })
        }
      })
    } catch (error) {
      const errors = { solved: error.message }
      this.setState({ errors })
    }
  }

  _handleChange = item => {
    const model = {
      ...this.state.model,
      [item.field]: item.value
    }
    this.setState({ model }, this._revalidate)
  }

  _revalidate = () => {
    const { submittedOneTime, errors } = this.state
    const count = Object.keys(errors).length
    if (submittedOneTime && count > 0) {
      const data = { ...this.state.model }
      surveyValidator.create(data).then(result => {
        this.setState({ errors: result.errors || {} })
      })
    }
  }

  _startNewChat = e => {
    const { manager } = this.props
    localStorage.removeItem('twilio-flex-cf');
    e.preventDefault()
    window.location.reload()
     FlexWebChat.Actions.invokeAction("RestartEngagement");
    
    FlexWebChat.Actions.invokeAction('StartEngagement', {
      formData: {
          friendlyName: '',
        ...window.sdwtc_data
      }
    })

    const state = manager.store.getState()
    const channelSid = state.flex.session.channelSid
    manager.chatClient.getChannelBySid(channelSid)
      .then(channel => {
        console.log(channel);
      })
  }
}
